import { useState, useEffect } from 'react';
import { Product } from './product/Product';
import { Modal } from '../modal/Modal';
import { AddProduct } from '../addProduct/AddProduct';
import Pagination from '@mui/material/Pagination';

import { usePagination } from "./pagination/Pagination";

import styles from './ProductPage.module.css';

export const ProductPage = ({ 
    isAuthorized, 
    products,
    isLoading,
    address, 
    addProductInCart,
    deletePurchasedProduct,
    cartList}) => {

    const [show, setShow] = useState(false);
    const [isClicked, setIsClicked] = useState([]);
    const [showModalAddProduct, setShowModalAddProduct] = useState(false);

    // PAGINATION
    const [currentPage, setCurrentPage] = useState(1);
    const PER_PAGE = 6;
    const count = Math.ceil(products?.length / PER_PAGE);
    const _DATA = usePagination(products, PER_PAGE);

    const handleChange = (e, p) => {
        setCurrentPage(p);
        _DATA.jump(p);
    };

    //MODAL
    let showModal = (id) => {
        setIsClicked(products.find(product => product.name === id));
        setShow(true);
    };
    let hideModal = () => {
        setShow(false);
        setIsClicked([]);
    };

    let showAddProduct = () => {
        setShowModalAddProduct(true);
    };
    let hideAddProduct = () => {
        setShowModalAddProduct(false);
    };

    return (
        <div className={styles.container}>

            {isAuthorized &&
            <div className={styles.addProduct}>
                <button
                    onClick={() => showAddProduct()}
                    className={styles.addProductButton}
                >Додати новий товар</button>
            </div>
            }

            <Product
                address={address}
                className={styles.card}
                products={_DATA.currentData()}
                isLoading={isLoading}
                isAuthorized={isAuthorized}
                showModal={showModal}
                addProductInCart={addProductInCart}
                deletePurchasedProduct={deletePurchasedProduct}
                cartList={cartList}
            />

            <Modal
                show={show}
                handleClose={hideModal}
                card={isClicked}
                isAuthorized={isAuthorized}
                addProductInCart={addProductInCart}
                deletePurchasedProduct={deletePurchasedProduct}
                cartList={cartList}>
            </Modal>

            <AddProduct
                address={address}
                showModalAddProduct={showModalAddProduct}
                hideAddProduct={hideAddProduct}>
            </AddProduct>

            <div className={styles.paginationContainer}>
                <Pagination
                    count={count}
                    size="large"
                    page={currentPage}
                    variant="outlined"
                    shape="rounded"
                    onChange={handleChange}
                />
            </div>
        </div>
    )
}